import {
    GET_TRANSFER_GRID_COUNT,
    GET_TRANSFER_GRID_DATA
} from 'Store/Transfer/TransferGrid/TransferGridType'
import TransferApiService from './TransferApiService'; 
import {setIsMyOrdersGridCountsLoading, setIsMyOrdersGridLoading, setTransferGridCount, setTransferGridData} from 'Store/Transfer/TransferGrid/TransferGridAction';
import {all,takeEvery,put,call, takeLatest} from 'redux-saga/effects'
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';


function* getTransferGridValue(req:any):any {
    yield put(setIsMyOrdersGridLoading(true))
    let payloadData : IPayload = {
        apiType : apiType.OrderManagement,
        endpoint : `orders/grid/nonrequisition`,
        apiMethod : apiMethod.POST,
        payload : req?.val
    }
    try {
        const response = yield call(TransferApiService.post, API_URL.PostWebApp, payloadData);
        if (response) {
            yield put(setTransferGridData(response))
        }
        yield put(setIsMyOrdersGridLoading(false))
    } catch (error) {
        yield put(setTransferGridData([]))
        yield put(setIsMyOrdersGridLoading(false))
    }
}

function* getTransferGridCount():any {
    yield put(setIsMyOrdersGridCountsLoading(true))
    let payloadData : IPayload = {
        apiType : apiType.OrderManagement,
        endpoint : `orders/grid/norequisition/count`,
        apiMethod : apiMethod.GET,
        payload : null
    }
    try {
        const response = yield call(TransferApiService.post, API_URL.PostWebApp, payloadData);
        if (response) {
            yield put(setTransferGridCount(response))
        }
        yield put(setIsMyOrdersGridCountsLoading(false))
    } catch (error) {
        yield put(setTransferGridCount([]))
        yield put(setIsMyOrdersGridCountsLoading(false))
    }
}

function* watchergetTransferGridValue() {
    yield takeLatest(GET_TRANSFER_GRID_DATA,getTransferGridValue)
    yield takeEvery(GET_TRANSFER_GRID_COUNT,getTransferGridCount)
}

export default function* combinedSaga() {
    yield all([
        watchergetTransferGridValue()
    ])
}